<template>
  <el-container>
    <el-aside width="auto">
      <CommonAside/>
    </el-aside>
    <el-container>
      <el-header height="40px">
        <CommonHeader/>
      </el-header>
      <!--暂时用不到tag-->
      <!--<CommonTag  v-show="$store.state.header.enableTag"/>-->
      <el-main>
        <!--切换页面后原路由不丢失-->
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>
      <MusicPlayer v-show="showPlayer"></MusicPlayer>

      <el-tooltip content="打开当前播放列表" placement="top" :open-delay="500">
        <el-button circle @click="openPlayList" type="primary" icon="el-icon-s-fold" style="position: fixed; right: 10px; bottom: 40px"></el-button>
      </el-tooltip>
      <!-- 播放列表 -->
      <el-drawer
          title="播放列表"
          :visible.sync="openPlayListDrawer"
          direction="rtl"
          :modal="false"
          size="50%"
          style="margin: 0 0 40px 0"
          :before-close="handleClose">
        <el-table :data="playList"
                  :row-class-name="tableRowClassName"
                  ref="playListTable"
                  height="100%"
                  @current-change="handleCurrentChange">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column property="title" label="歌名" width="150"></el-table-column>
          <el-table-column property="artist" label="歌手" width="100"></el-table-column>
          <el-table-column property="album" label="专辑"></el-table-column>
          <el-table-column property="quality" label="音质" width="100">
            <template slot-scope="scope">
              <template v-if="scope.row.quality === 'normal'">
                <!--<el-tooltip content="普通音质" placement="bottom">-->
                  <el-tag title="普通音质" type="primary">普通</el-tag>
                <!--</el-tooltip>-->
              </template>
              <template v-else-if="scope.row.quality === 'HQ'">
                <el-tooltip placement="bottom" content="HQ音质">
                  <el-tag type="success">HQ</el-tag>
                </el-tooltip>
              </template>
              <template v-else-if="scope.row.quality === 'SQ'">
                <el-tooltip placement="bottom" content="SQ音质">
                  <el-tag type="warning">SQ</el-tag>
                </el-tooltip>
              </template>
              <template v-else-if="scope.row.quality === 'Res'">
                <el-tooltip placement="bottom" content="Hi-Res音质">
                  <el-tag type="danger">Res</el-tag>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip placement="bottom" content="普通音质">
                  <el-tag type="primary">普通</el-tag>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <!--使用.stop组织事件冒泡-->
              <el-button type="danger" title="从播放列表移除" @click.stop="removeFromPlayList(scope.row)" circle plain icon="el-icon-delete" size="small"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-drawer>

      <el-footer height="40px" style="padding: 0">
        <CommonFooter />
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import CommonHeader from "../components/CommonHeader";
import CommonAside from "../components/CommonAside";
// import CommonTag from "../components/CommonTag";
import CommonFooter from "../components/CommonFooter";
import MusicPlayer from "../components/MusicPlayer";
import {getPlatInfoList} from "../api/music";
export default {
  name: "Main",
  components: {MusicPlayer, CommonFooter, CommonAside, CommonHeader},
  data() {
    return {
      openPlayListDrawer: false,
      playList:[
        {
          audioId: '',
          title: '',
          artist: '',
          src: '',
          pic: '',
          lrc: '',
          album: '',
          quality: ''
        },
      ],
      showPlayer: true
    }
  },
  methods: {
    openPlayList() {
      this.openPlayListDrawer = true
      this.playList = this.$store.state.music.playList
    },
    // 处理行点击事件。有大坑：删除该行时，也会触发这个事件
    handleCurrentChange(row) {
      console.log('main play list drawer table data current changed')
      this.$bus.$emit('playMusic', row)
    },
    handleClose() {
      this.openPlayListDrawer =false
    },
    // 从播放列表中移除
    removeFromPlayList(row) {
      console.log('main  移除播放列表元素')
      console.log(row)
      console.log(this.playList)
      // 从播放列表中移除该歌曲
      this.$bus.$emit('removePlayListItem', row)
      // 加延时
      this.playList = this.$store.state.music.playList
    },

    setPlayingRowClass() {

    },
    // 根据当前播放数据设置播放列表中行样式
    tableRowClassName({row, rowIndex}) {
      if (this.$store.state.music.currentPlaySrc === row.src) {
        // 这个定义在了app.vue中。需要定义在全局样式中，定义在局部（scoped）style中都没有效果
        return 'success-row';
      }
      return '';
    },

    // 控制是否展示播放器
    setShowPlayer(show) {
      this.showPlayer = show
    }
  },
  computed: {
  },
  watch: {
    $route(to) {
      if (to.path === '/list') {
        this.showPlayer = true
      } else if (to.path === '/search') {
        this.showPlayer = this.$store.state.music.playList.length > 0;
      } else {
        this.showPlayer = false
      }
    },
  },

  mounted() {
    this.$bus.$on('setShowPlayer', this.setShowPlayer)
    this.showPlayer = localStorage.getItem('showPlayer') === 't'
  },

  beforeCreate() {
    // 获取平台列表
    getPlatInfoList().then(res=>{
      const data = res.data
      if (!data.success) {
        this.$message.error('获取平台列表失败！')
        return
      }
      const list = data.data
      const idObj = {
        kuwo: list.find(item => item.name === 'kuwo').id,
        kugou: list.find(item => item.name === 'kugou').id,
        bilibili: list.find(item => item.name === 'bilibili').id,
      }
      this.$store.commit('music/setPlatInfoList', data.data)
      this.$store.commit('music/setPlatIds', idObj)
    })
  },

  beforeDestroy() {
    this.$bus.$off()
  }
}
</script>

<style lang="less" scoped>
.el-container {
  height: 100%;
  .el-header {
    padding: 0;
  }
  .el-main {
    background-color: whitesmoke;
    padding: 0;
  }
}
</style>
